import React from 'react';
import TagsBox from '../../TagsBox';
import PropertyIcon from '../../DisplayProperty/View/PropertyIcon.view';
import labelIcon from '../../../images/tag_left_point.jpg';
import attributeIcon from '../../../images/enter_icon.jpg';
import Dot from '../../Dot';
import '../Style/PreEvaluationDetails.css';
import {IPropsView} from '../Config/PreEvaluationDetails.types';
import {BackendQueryField} from '../../../configuration/backendFileds/backendFileld.config';
import {_SYSTEM_TITLES} from '../../../configuration/SystemTitles/SystemTitles.config';
import ImageAmount from '../../ImageAmount';

const PreEvaluationDetails = ({query, findLabel, findAttribute}:IPropsView) => (
    <div className='query-box-eval-with-errors-container'>
        <div className='pre-evaluation-popup-query-box'>
            <TagsBox tags={query.tag} className='tag-pre-evaluation'/>
            {<div className='popup-query-box-property-icon'>
                { findLabel(query).id > -1 && <PropertyIcon maxLenString={14} mainClassName='query-box-properties-name' property={findLabel(query)} icon={labelIcon} />}
                {findAttribute(query).id > -1 && <PropertyIcon maxLenString={14} mainClassName='query-box-properties-name' property={findAttribute(query)} icon={attributeIcon} />}
            </div>}
            <div className='popup-query-box-eval'>
                <ImageAmount
                    toolTipTitle={_SYSTEM_TITLES.trainingDataTitle}
                    isError={query[BackendQueryField.error] && query[BackendQueryField.error].length > 0 }
                    amount={query[BackendQueryField.trainingAmount]}
                />
                <ImageAmount
                    type='evaluation'
                    toolTipTitle={_SYSTEM_TITLES.evaluationDataTitle}
                    isError={query.error }
                    amount={query[BackendQueryField.evalAmount]}
                />
            </div>
        </div>
        {query[BackendQueryField.error] && query[BackendQueryField.error].length > 0 && <div className='query-box-eval-errors-container'>
            {query[BackendQueryField.error].map((err, i) => <div key={i} className='eval-errors-container'>
                <Dot color='red' size='small' position='eval-error'/>
                <p className='query-box-eval-errors-p'>{err}</p>
            </div>)}
        </div>}
    </div>
);

export default PreEvaluationDetails;
